export { SUPORT_AREA_PT_BR } from "./suport-area-pt-br";
export type { SuportAreaTranslations } from "./suport-area-pt-br";
export { SUPORT_AREA_EN_US } from "./suport-area-en-us";
export { SUPORT_AREA_ES_ES } from "./suport-area-es-es";
export { SUPORT_AREA_ES_MX } from "./suport-area-es-mx";
export { SUPORT_AREA_FR_FR } from "./suport-area-fr-fr";
